import { api } from './apiClient';
import { logger } from './logger';

const LIBRARY_ENDPOINT = '/api/library';

const libraryService = {
  getLibraryTemplates: async () => {
    try {
      const data = await api.get(LIBRARY_ENDPOINT);
      return Array.isArray(data) ? data.map(t => ({
        ...t,
        id: t.id || t.Id,
        name: t.name || t.Name,
        description: t.description || t.Description,
        category: t.category || t.Category,
        company: t.company || t.Company,
        createdBy: t.createdBy || t.CreatedBy,
        createdAt: t.createdAt || t.CreatedAt,
        validationRulesCount: t.validationRulesCount || t.ValidationRulesCount || 0,
        gdbStructureJson: t.gdbStructureJson || t.GdbStructureJson,
        isLibrary: true,
      })) : [];
    } catch (error) {
      logger.error('Error obteniendo plantillas de la Biblioteca', { error: error.message });
      throw error;
    }
  },

  cloneFromLibrary: async (sourceId, cloneData) => {
    try {
      const result = await api.post(`${LIBRARY_ENDPOINT}/clone/${sourceId}`, {
        NewName: cloneData.name,
        Description: cloneData.description,
      });
      return result;
    } catch (error) {
      logger.error(`Error clonando plantilla de biblioteca ${sourceId}`, { error: error.message });
      throw error;
    }
  },

  publishToLibrary: async (id) => {
    try {
      return await api.put(`${LIBRARY_ENDPOINT}/${id}/publish`, {});
    } catch (error) {
      logger.error(`Error publicando plantilla ${id} en Biblioteca`, { error: error.message });
      throw error;
    }
  },

  unpublishFromLibrary: async (id) => {
    try {
      return await api.del(`${LIBRARY_ENDPOINT}/${id}/publish`);
    } catch (error) {
      logger.error(`Error retirando plantilla ${id} de la Biblioteca`, { error: error.message });
      throw error;
    }
  },
};

export default libraryService;
